export function updateUrlQueryWithoutNavigation(
  params: Record<string, string | undefined>,
): void {
  if (typeof window === 'undefined') return

  const url = new URL(window.location.href)
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined) {
      url.searchParams.delete(key)
    } else {
      url.searchParams.set(key, value)
    }
  })
  window.history.replaceState(window.history.state, '', url.toString())
}
